export default __webpack_public_path__ + "static/media/emergency.d9094f69.gif";